// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './SlideStyles.css'

function FileIconsSlide() {
  return (
    <div className="slide-content feature-slide">
      <div className="feature-demo">
        <iframe width="100%"
            src="https://www.youtube.com/embed/J_MUCYT_1Sg?autoplay=1&mute=0&loop=1&playlist=J_MUCYT_1Sg"
            title="File and Folder Icons demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen></iframe>
      </div>

      <div className="feature-header">
        <div className="feature-category">File and Folder Icons</div>
        <h2 className="slide-title">Customize icons to organize visually</h2>
        <p className="slide-text">
          Personalize your folders and files with distinctive icons to make important items
          easy to spot. Improve discoverability and keep your workspace visually organized.
        </p>
      </div>
    </div>
  )
}

export default FileIconsSlide
